let globalLogLevel = 'info';
export default class Logger {

  public static setLogLevel(logLevel: string) {
    globalLogLevel = logLevel;
  }
  public static info(msg: string): void {
    if(globalLogLevel === 'none') return;
    /* eslint-disable-next-line  no-console */
    console.log(msg);
  }
  public static warn(msg: string): void {
    if(globalLogLevel === 'none') return;
    /* eslint-disable-next-line  no-console */
    console.warn(msg);
  }
  public static error(msg: string): void {
    if(globalLogLevel === 'none') return;
    /* eslint-disable-next-line  no-console */
    console.error(msg);
  }
  public static errorAny(error: any): void {
    if(globalLogLevel === 'none') return;
    /* eslint-disable-next-line  no-console */
    console.error(error);
  }
  public static debug(msg: string): void {
    if(globalLogLevel === 'none') return;
    if(globalLogLevel !== 'debug') return;
    /* eslint-disable-next-line  no-console */
    console.log(msg);
  }
}
